"use client";

import React from "react";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { Drawer } from "@/components/common/Drawer";
import { closed } from "@/redux/slices/drawerSlice";
import CategoryForm from "@/modules/category/CategoryForm";
import DiscountForm from "@/modules/discount/DiscountForm";
import PaymentMethodForm from "@/modules/payment-method/PaymentMethodForm";
import SettingForm from "@/modules/setting/SettingForm";
import PriceRangeForm from "@/modules/price-range/PriceRangeForm";
import TestimonialForm from "@/modules/testimonial/TestimonialForm";

const drawerComponents: Record<string, React.JSX.Element> = {
  categoryForm: <CategoryForm />,
  discountForm: <DiscountForm />,
  paymentMethodForm: <PaymentMethodForm />,
  settingForm: <SettingForm />,
  priceRangeForm: <PriceRangeForm />,
  testimonialForm: <TestimonialForm />,
};

export const GlobalDrawerManager: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isOpen, name, title, data, variant, width } = useAppSelector((state) => state.drawer);

  const handleClose = () => {
    dispatch(closed());
  };

  const content = drawerComponents[name];

  return (
    <Drawer
      isOpen={isOpen}
      onClose={handleClose}
      variant={variant}
      width={width}
      title={title || (data ? `Edit ${name?.replace("Form", "")}` : `Add ${name?.replace("Form", "")}`)}
      className={variant === "light" ? "border-l-4 border-l-gold-core" : "shadow-[0_0_40px_rgba(201,151,26,0.15)]"}
    >
      {isOpen && content ? (
        <div className="global-drawer-content">
          {content}
        </div>
      ) : null}
    </Drawer>
  );
};
